import { Injectable } from "@angular/core";

import { map, Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";

import { ConstantService } from "src/app/core/services/constant.service";

@Injectable()
export class GroupPermissionService {
  private groupPermissionsUrl = ConstantService.GROUP_PERMISSION_URL;

  constructor(private http: HttpClient) {}

  getGroupPermissions(executive_id: string): Observable<any> {
    return this.http
      .get<{}>(`${this.groupPermissionsUrl + "group_permissions/"}?executive_id=${executive_id}`)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  post(data: any): Observable<any> {
    return this.http.post<any>(this.groupPermissionsUrl, data).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  patchPermission(id: number | string, data: any): Observable<any> {
    return this.http.patch<any>(`${this.groupPermissionsUrl}${id}`, data).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  getPermissions(params: any): Observable<any> {
    let httpParams = new HttpParams()
      .set("executive_id", params.executive_id)
      .set("permissionLevel", params.permissionLevel);

    if (params.module_id != null) {
      httpParams = httpParams.set("module_id", params.module_id);
    }

    if (params.menu_id != null) {
      httpParams = httpParams.set("menu_id", params.menu_id);
    }

    if (params.project_id != null && params.project_id !== "") {
      httpParams = httpParams.set("project_id", params.project_id);
    }

    if (params.insurer_code != null && params.insurer_code !== "") {
      httpParams = httpParams.set("insurer_code", params.insurer_code);
    }

    return this.http.get<any>(this.groupPermissionsUrl, { params: httpParams });
  }

  deletePermission(id: number): Observable<any> {
    const url = `${this.groupPermissionsUrl}${id}`;
    return this.http.delete<any>(url).pipe(map((response) => response));
  }
}
